webpackJsonp([212839066777427],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pagination(props) {
	  if (props.pages > 1) {
	    return _react2.default.createElement(
	      "ul",
	      { className: "pagination" },
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' },
	          "First"
	        )
	      ),
	      props.pl.map(function (i) {
	        return _react2.default.createElement(
	          "li",
	          { key: 'pagkey' + i.number, className: i.status },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/blog/' + (i.number > 1 ? i.number : '') },
	            i.number
	          )
	        );
	      }),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' + props.max },
	          "Last"
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	}
	
	function Index(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var posts = data.allMarkdownRemark.edges;
	
	  var fin = [];
	  var per = pathContext.per ? pathContext.per : 3;
	  var min = pathContext.per ? pathContext.per * pathContext.page - pathContext.per : 0;
	  var max = pathContext.per ? min + pathContext.per : 2;
	
	  for (var i = 0; i < posts.length; i++) {
	    if (i >= min && i <= max) {
	      fin.push(posts[i]);
	    }
	  }
	
	  var pl = [];
	  for (var i = 1; i <= Math.ceil(data.allMarkdownRemark.totalCount / per); i++) {
	    pl.push({ number: i, status: pathContext.page && pathContext.page == i || !pathContext.page && i == 1 ? 'current' : '' });
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "page-wrapper" },
	    _react2.default.createElement(_reactHelmet2.default, { title: "Blog of much banalities" }),
	    _react2.default.createElement(
	      "section",
	      { className: "blog-hero" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Blog of much banalities"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Ugh... read on if you can stand it. (page ",
	        pathContext.page ? pathContext.page : 1,
	        ")"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "blog-posts" },
	      fin.filter(function (post) {
	        return post.node.frontmatter.title.length > 0;
	      }).map(function (_ref2) {
	        var post = _ref2.node;
	
	        return _react2.default.createElement(
	          "div",
	          { className: "blog-post-preview", key: post.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.frontmatter.path, className: "blog-image", style: { backgroundImage: 'url(' + post.frontmatter.image + ')' } },
	            _react2.default.createElement("img", { src: post.frontmatter.image, alt: post.frontmatter.title }),
	            _react2.default.createElement(
	              "span",
	              { className: "date" },
	              post.frontmatter.date
	            )
	          ),
	          _react2.default.createElement(
	            "h2",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.frontmatter.path },
	              post.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            post.excerpt
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(Pagination, { pages: Math.ceil(data.allMarkdownRemark.totalCount / per), pl: pl, max: Math.ceil(data.allMarkdownRemark.totalCount / per) })
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-2af1be4432cb3e8bb012.js